import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';
import {replaceItem, removeItem} from '../../common/util/array';
import {downloadFile} from '../../common/util/file';

const INITIAL_STATE = {
  'loading': false,
  'loadingDetail': false,
  'creating': false,
  'processing': false,
  'deleting': false,
  'list': [],
  'selectedOrder': null,
  'orderDetail': [],
};

const updateDetailClaimValue = (detail, {claimCode, name, value}) => {
  const index = detail.findIndex((claim) => claim.code === claimCode);

  if (index === -1) {
    return detail;
  }

  const updatedClaim = {...detail[index], [name]: value};
  return replaceItem(detail, index, updatedClaim);
};

const saveReturnClaim = (detail, claim, index) => {
  if (index !== 0 && !index) {
    return [...detail, claim];
  }

  return replaceItem(detail, index, claim);
};

const updateClaimAttachment = (detail, attachment) => {
  const index = detail.findIndex(
    (claim) => claim.code === attachment.requestCode
  );

  if (index > -1) {
    const updatedClaim = {
      ...detail[index],
      'attachments': [...detail[index].attachments, attachment],
    };
    return replaceItem(detail, index, updatedClaim);
  }

  return detail;
};

const removeClaimAttachment = (detail, reference) => {
  const index = detail.findIndex((claim) => claim.code === reference.claimCode);
  alert(index); //eslint-disable-line

  if (index > -1) {
    const updatedClaim = {...detail[index]};
    const fileIndex = updatedClaim.attachments.findIndex(
      (file) => file.code === reference.attachmentCode
    );
    alert(fileIndex); //eslint-disable-line

    if (fileIndex > -1) {
      updatedClaim.attachments = removeItem(
        updatedClaim.attachments,
        fileIndex
      );
      return replaceItem(detail, index, updatedClaim);
    }

    return detail;
  }

  return detail;
};

export const partsReturnsOrders = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_PART_RETURNS_ORDERS_LIST]: (state, action) => ({
      ...state,
      'list': [],
    }),
    [ActionTypes.SELECT_PART_RETURN_ORDER]: (state, action) => ({
      ...state,
      'selectedOrder': action.payload,
    }),
    [ActionTypes.CLEAR_PART_RETURN_ORDER]: (state, action) => ({
      ...state,
      'selectedOrder': null,
      'orderDetail': [],
    }),
    [ActionTypes.SAVE_RETURN_CLAIM]: (state, action) => ({
      ...state,
      'orderDetail': saveReturnClaim(
        state.orderDetail,
        action.payload.claim,
        action.payload.index
      ),
    }),
    [ActionTypes.UPDATE_PART_RETURN_ORDER_VALUE]: (state, action) => ({
      ...state,
      'orderDetail': updateDetailClaimValue(state.orderDetail, action.payload),
    }),
    [ActionTypes.GET_PART_RETURNS_ORDERS_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.GET_PART_RETURNS_ORDERS_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.GET_PART_RETURNS_ORDERS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.GET_PART_RETURN_DETAIL_REQUEST]: (state, action) => ({
      ...state,
      'loadingDetail': true,
    }),
    [ActionTypes.GET_PART_RETURN_DETAIL_SUCCESS]: (state, action) => ({
      ...state,
      'loadingDetail': false,
      'orderDetail': action.response.data,
    }),
    [ActionTypes.GET_PART_RETURN_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loadingDetail': false,
      'orderDetail': [],
    }),
    [ActionTypes.EXPORT_PARTS_RETURN_ORDERS_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.EXPORT_PARTS_RETURN_ORDERS_SUCCESS]: (state, action) => {
      downloadFile(action.response.data);

      return {
        ...state,
        'loading': false,
      };
    },
    [ActionTypes.EXPORT_PARTS_RETURN_ORDERS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.CREATE_PARTS_RETURN_ORDER_REQUEST]: (state, action) => ({
      ...state,
      'creating': true,
    }),
    [ActionTypes.CREATE_PARTS_RETURN_ORDER_SUCCESS]: (state, action) => ({
      ...state,
      'creating': false,
      'selectedOrder': action.response.data,
    }),
    [ActionTypes.CREATE_PARTS_RETURN_ORDER_FAILED]: (state, action) => ({
      ...state,
      'creating': false,
    }),
    [ActionTypes.PROCESS_PARTS_RETURN_ORDER_REQUEST]: (state, action) => ({
      ...state,
      'processing': true,
    }),
    [ActionTypes.PROCESS_PARTS_RETURN_ORDER_SUCCESS]: (state, action) => ({
      ...state,
      'processing': false,
      'selectedOrder': null,
      'orderDetail': [],
    }),
    [ActionTypes.PROCESS_PARTS_RETURN_ORDER_FAILED]: (state, action) => ({
      ...state,
      'processing': false,
    }),
    [ActionTypes.DELETE_PARTS_RETURN_ORDER_REQUEST]: (state, action) => ({
      ...state,
      'deleting': true,
    }),
    [ActionTypes.DELETE_PARTS_RETURN_ORDER_SUCCESS]: (state, action) => ({
      ...state,
      'deleting': false,
      'selectedOrder': null,
      'orderDetail': [],
    }),
    [ActionTypes.DELETE_PARTS_RETURN_ORDER_FAILED]: (state, action) => ({
      ...state,
      'deleting': false,
    }),
    [ActionTypes.ADD_RETURN_CLAIM_ATTACHMENT_SUCCESS]: (state, action) => ({
      ...state,
      'orderDetail': updateClaimAttachment(
        state.orderDetail,
        action.response.data
      ),
    }),
    [ActionTypes.REMOVE_RETURN_CLAIM_ATTACHMENT_SUCCESS]: (state, action) => ({
      ...state,
      'orderDetail': removeClaimAttachment(
        state.orderDetail,
        action.response.data
      ),
    }),
  })(state, action);
};
